import findIndex from 'lodash/findIndex';

export default (state = [], action = {}) => {
  switch(action.type) {
    case 'FETCH_TODOLISTS':
      return action.data;
    case 'EDIT_TODOLIST':
      const index = findIndex(
        state,
        { todolist_id: action.payload.todolist_id }
      );
      if (index >= 0) {
        const newState = [
          ...state.slice(0, index),
          action.payload,
          ...state.slice(index + 1)
        ]
        return newState;
      }
      return state;
    case 'CREATE_TODOLIST':
      return [
        ...state,
        action.payload
      ]
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/todolists.js